<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row" style="">
    <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
        <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
            <span style="float:left">Upcoming registrations and forms</span>
        </h6>
    </div>
    <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
        <div class="col-md-12 col-sm-12 ">
            <div class="row">
                <div *ngIf="isLoading" class="col-xl-12" style="margin-bottom:20px">
                    <div style="text-align: right" class="clearfix">
                        <div class="spinner-border float-right" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isLoading" class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:20px">
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search...</label>
                    </div>
                </div>

            </div>
            <div *ngIf="!isLoading" class="row" style="margin-bottom:10px">
                <div class="col-xl-3 col-md-6 col-xs-6 col-sm-6" *ngFor="let category of formCategories " style="margin-bottom: 10px;">
                    <a (click)="applyCategoryFilter(category.code)" [ngStyle]="{'background-color': category.isActive ? category.active_background_color : category.inactive_background_color, 'color': category.isActive ? category.active_color : category.inactive_color, 'border-color': category.inactive_color }" style="width: 100%; font-size: 13px; height: 35px; margin-right: 20px; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                        {{category.name}}
                    </a>
                </div>
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                    <!-- ID Column -->
                    <ng-container matColumnDef="form">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Upcoming registrations and forms </th>
                        <td mat-cell *matCellDef="let row">

                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px; padding-top: 10px;">
                                <b>{{row.name}}</b>
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom:20px">
                                {{row.rightBox}}
                            </div>
                            <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom:20px">
                                <span *ngIf="row.category == 'event'" style="background-color: orange; padding: 3px; border-radius: 5px; color: white;">Event</span>
                                <span *ngIf="row.category == 'training'" style="background-color: green; padding: 3px; border-radius: 5px; color: white;">Training</span>
                                <span *ngIf="row.category == 'webinar'" style="background-color: red; padding: 3px; border-radius: 5px; color: white;">Webinar</span>
                                <span *ngIf="row.category == 'other'" style="background-color: grey; padding: 3px; border-radius: 5px; color: white;">Other</span>
                                <span style="float: right; opacity: .5;">Open till {{row.endDate | date : 'medium'}}</span>
                            </div>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr class="table_row" mat-row (click)="openForm(row.code)" *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="1">{{loadingMessage}}</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
            </div>

        </div>

    </div>

</div>







<!--<div *ngIf="accessdenied && !isLoading" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="block-style" style="padding-top:40px">
        <div class="row">
            <div *ngIf="forms.length == 0 && !isLoading" class="col-md-12 no-padding">
                <div class="alert alert-danger text-center" role="alert">
                    No forms available
                </div>
            </div>
            <div *ngFor="let form of forms" class=" col-md-4" style="margin-bottom:30px;cursor:pointer">
                <div (click)="openForm(form.code)" class="card" style="min-height: 300px;">
                    <img [src]="form.coverPhoto">
                    <div class="card-body">
                        <div class="col-xl-8 no-padding" style="margin-bottom: 10px;">
                            <span class="box-category">{{form.category}}</span>
                        </div>
                        <p class="card-text">{{form.name}}</p>
                    </div>
                </div>
            </div>
            <div *ngIf="isLoading" class=" col-md-4" style="margin-bottom:30px;cursor:pointer">
                <app-page-loading></app-page-loading>
            </div>
        </div>

    </div>


</div>-->